import React from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Text,
  VStack,
  Textarea,
} from '@chakra-ui/react';

const StatusUpdateModal = ({ isOpen, onClose, onConfirm, status, loading, description }) => {
  const [reason, setReason] = React.useState('');
  
  const handleConfirm = () => {
    onConfirm(status, reason);
    setReason('');
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 'Approved':
        return 'green';
      case 'Rejected':
        return 'red';
      case 'Under Review':
        return 'purple';
      case 'Incomplete':
        return 'yellow';
      case 'Pending':
        return 'orange';
      case 'Funded':
        return 'teal';
      case 'Closed':
        return 'blue';
      case 'Deleted':
        return 'gray';
      default:
        return 'blue';
    }
  };

  const needsReason = (status) => {
    return status === 'Rejected' || status === 'Incomplete';
  };

  const getPlaceholder = (status) => {
    switch (status) {
      case 'Rejected':
        return 'Please provide a reason for rejection';
      case 'Incomplete':
        return 'Please specify what additional documents are required';
      default:
        return '';
    }
  };

  const formatStatus = (status) => {
    if (!status) return '';
    return status;
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay backdropFilter="blur(4px)" />
      <ModalContent>
        <ModalHeader>Confirm Status Update</ModalHeader>
        <ModalBody>
          <VStack spacing={4} align="stretch">
            <Text>
              {description ? (
                description
              ) : (
                <>
                  Are you sure you want to change the status to{' '}
                  <Text as="span" color={`${getStatusColor(status)}.500`} fontWeight="bold">
                    {formatStatus(status)}
                  </Text>
                  ?
                </>
              )}
            </Text>
            
            {needsReason(status) && (
              <Textarea
                value={reason}
                onChange={(e) => setReason(e.target.value)}
                placeholder={getPlaceholder(status)}
                required
              />
            )}
          </VStack>
        </ModalBody>

        <ModalFooter>
          <Button variant="ghost" mr={3} onClick={onClose}>
            Cancel
          </Button>
          <Button
            colorScheme={getStatusColor(status)}
            onClick={handleConfirm}
            isLoading={loading}
            isDisabled={needsReason(status) && !reason.trim()}
          >
            Confirm
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default StatusUpdateModal;
